import React, { PureComponent } from 'react';

import ProgressBar from 'react-bootstrap/ProgressBar'
import '../../../scss/component/statistics.scss';

export default class Progress extends PureComponent {

    render(){
        let progressBar;

          if(this.props.data == null){
            progressBar =  <h5>Score will be displayed at the completion of the {this.props.assessmentName.toUpperCase()} Compliance assessment.</h5>
          }
          else if(this.props.data.score >= 0 && this.props.data.score <= 25){
            progressBar = <ProgressBar striped animated variant="customProgressLow" now={this.props.data.score} 
                    label={`${this.props.data.score}%`}/>
          } 
          else if (this.props.data.score > 25 && this.props.data.score <= 75){
            progressBar = <ProgressBar striped animated variant="customProgressMedium" now={this.props.data.score} 
                    label={`${this.props.data.score}%`}/>
          }
          else{
            progressBar = <ProgressBar striped animated variant="customProgressHigh" now={this.props.data.score} 
                    label={`${this.props.data.score}%`}/>
          }

        return(
            progressBar
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/compliance/components/ProgressBar.js